import { Button, ButtonProps } from 'react-bootstrap';

type SecondaryButtonProps =
  Omit<
  ButtonProps,
  'className' | 'bsPrefix' | 'variant'>;

const SecondaryButton = (props: SecondaryButtonProps) => <Button variant='nmi-secondary' {...props} />;

export default SecondaryButton;
